import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

// Component for fetching and displaying featured image
function FeaturedImage({ mediaId, title }) {
    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        if (mediaId) {
            wp.apiFetch({ path: `/wp/v2/media/${mediaId}` })
                .then((media) => setImageUrl(media.source_url))
                .catch((error) => console.error("Error fetching media:", error));
        }
    }, [mediaId]);

    return imageUrl ? <img src={imageUrl} alt={title.rendered} /> : null;
}

// Component for fetching and displaying child items
function ChildItems({ parentId, articlesNumber, parent_docs_order, menuOrder, onCountUpdate }) {
    
    const docItems = useSelect(
        (select) =>
            select("core").getEntityRecords("postType", "docs", {
                per_page: articlesNumber || 10,
                order: parent_docs_order,
				orderby: menuOrder,
                parent: parentId,
                status: ["publish", "private"],
            }),
        [parentId, articlesNumber, parent_docs_order, menuOrder]
    );

    useEffect(() => {
        if (onCountUpdate) {
            onCountUpdate(docItems?.length || 0);
        }
    }, [docItems, onCountUpdate]);

    if (!docItems) return;
    if (docItems.length === 0) return <ul class="ezd-list-unstyled"><li> <a className="ct-content-text"> <i className="icon_document_alt"></i> No child items available. </a></li></ul>

    return (
        <ul className="ezd-list-unstyled">
            {docItems.map((item) => (
                <li key={item.id}>
                    <a className="ct-content-text" href="">
                        <i className="icon_document_alt"></i>
                        {item.title.rendered}
                    </a>
                </li>
            ))}
        </ul>
    );
}

// Main box component
export default function Box({ attributes, docSections, multiDocs, articlesNumber }) {
    const { col, docs_layout, readMoreText, orderBy, parent_docs_order, child_docs_order, show_topic, isFeaturedImage } = attributes;

    // Determine layout type
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;
 
    return (
        <div className={`${layoutType}`}>
            {(docSections || multiDocs) &&
                [...(docSections || []), ...(multiDocs || [])].map((section) => {
                    const { id, title, featured_media } = section;

                    return (
                        <div key={id} className="topic_list_item box-item wow fadeIn" data-wow-delay="0.2s">
                            <a href="" className="topic-title">

                            {isFeaturedImage && (
                                <FeaturedImage mediaId={featured_media} title={title} />
                            )}
                                <h4 className="ct-heading-text">{title.rendered}</h4>
                                
                                {show_topic && (
                                    <span className="ezd-badge ezd-circle">{articlesNumber}</span>
                                )}

                            </a>
                            
                            <ChildItems parent_docs_order={child_docs_order} menuOrder={orderBy} parentId={id} articlesNumber={articlesNumber} />

                            {readMoreText && (                                
                                <a href="" className="text_btn dark_btn">
                                    {readMoreText} <i className="arrow_right"></i>
                                </a>
                            )}
                        </div>
                    );
                })}
        </div>
    );
}
